import { ToastAction, ToastActionHandler, ToastActionLink } from "./types";

export const actionIsLink = (
  action: ToastAction
): action is ToastActionLink => {
  return "link" in action;
};
export const actionIsHandler = (
  action: ToastAction
): action is ToastActionHandler => {
  return "handler" in action;
};
